// removed by extract-text-webpack-plugin
module.exports = {"component":"_1SwoAoLdFMtZIe1eyrwCT9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SecondaryHeaderBar/SecondaryHeaderBar.css
// module id = 1291
// module chunks = 0